import { ROLE_BOM } from "@/lib/utils";
import { RootState } from "@/redux/store";
import {
  useGetCommunityNewsSettings,
  useGetNewsletter,
} from "@/services";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useNewsLetterCard = () => {
  const [flashNews, setFlashNews] = useState([
    { text: "", expiry: "" },
    { text: "", expiry: "" },
  ]);

  const [selectedNewsletter, setSelectedNewsletter] = useState<string>("");

  const [files, setFiles] = useState([
    {
      title: "Newsletter 1",
      name: "",
      size: 3000,
      id: 1,
    },
    {
      title: "Newsletter 2",
      name: "",
      size: 3000,
      id: 2,
    },
  ]);

  const {
    communityData: communityDetail,
    currentFinanceYear,
    currentRole,
  } = useSelector((state: RootState) => state.currentData);

  const isBom = currentRole == ROLE_BOM;

  const {
    data: communityNewsSettings,
    isLoading: isLoadingNewsLoading,
    isError: isNewsSettingsError,
  } = useGetCommunityNewsSettings({
    community_id: communityDetail?.communityId || "",
    queryParams: {
      enabled: !!communityDetail?.communityId,
    },
  });

  const { data: newsLetter, isLoading: isNewsLetterLoading } = useGetNewsletter(
    {
      community_id: communityDetail?.communityId || "",
      newsletter_no: selectedNewsletter,
      queryParams: {
        enabled: !!(communityDetail?.communityId && selectedNewsletter),
      },
    }
  );

  useEffect(() => {
    const loadImage = async () => {
      if (!newsLetter) return;

      window.open(newsLetter?.data, "blank");

      setTimeout(() => {
        setSelectedNewsletter("");
      }, 100);
    };

    loadImage();
  }, [newsLetter]);

  useEffect(() => {
    if (communityNewsSettings) {
      const _files = new Array(2)
        .fill(0)
        ?.map((file: any, index: number) => ({
          ...file,
          name:
            communityNewsSettings?.data?.[`newsletter${index + 1}FileName`] ||
            null,
          id: index,
        }))
        ?.filter((data: any) => data?.name);

      setFiles([..._files]);

      const _news = new Array(2)
        .fill(0)
        ?.map((news: any, index: number) => ({
          ...news,
          text: communityNewsSettings?.data?.[`flashNews${index + 1}`] || null,
          expiry: communityNewsSettings?.data?.[`flashNews${index + 1}Expiry`],
        }))
        ?.filter(
          (data: any) => data?.text && moment().isBefore(moment(data?.expiry))
        );

      setFlashNews([..._news]);
    } else if (isNewsSettingsError) {
      setFlashNews([]);
      setFiles([]);
    }
  }, [communityNewsSettings, isNewsSettingsError]);

  const onNewsletterClick = (index: number) => {
    setSelectedNewsletter(String(index + 1));
  };

  return {
    files,
    flashNews,
    setSelectedNewsletter,
    onNewsletterClick,
    isLoadingNewsLoading,
    isNewsLetterLoading,
    currentFinanceYear,
    isBom,
  };
};

export default useNewsLetterCard;
